import React, {useCallback, useEffect, useState} from 'react';
import {Box, Fade, Modal, Typography} from "@mui/material";
import Backdrop from '@mui/material/Backdrop';
import {crm, global, sip, input, lang} from "../translate";
import CreateAndEditCrm from "./CreateAndEditCrm";
import {useDispatch, useSelector} from "react-redux";
import {crmSingleRequest, sipEditRequest, sipSingleRequest} from "../store/actions/sip";
import {toast} from "react-toastify";
import {crmRequest} from "../store/actions/crm";
import _ from 'lodash'
import Api from "../Api";
import TelegramIcon from '@mui/icons-material/Telegram';
import Telegram from "./Telegram";
import TelegramDelete from "./TelegramDelete";
import {useLocation, useNavigate} from "react-router-dom";
import qs from "query-string";
import Cookies from "js-cookie";
import Select from "react-select";
import CloseIcon from "@mui/icons-material/Close";
import OperatorAccess from "./OperatorAccess";
import Utils from "../Utils";
const {REACT_APP_SERVER} = process.env;

import {style,customStyles} from "../helpers/style";

function EditSip({open, setOpen,code}) {
    const [checked, setChecked] = useState(true)
    const [telegram, setTelegram] = useState({pass:'',buddy:open,phone:''})
    const [edit, setEdit] = useState({
        pass: '',
        rec: 0,
        rate: 0,
        isspyadmin: 0,
        sip_noanswer:'',
        reenter: '',
        email: '',
        out: '',
        mob: 0,
        fixed: 0,
        inter: 0,
        payed: 0,
        isSip: 0,
        isWeb: 0,
        history: 0,
        isspeech: 0,
        note: '',
        ip: '',
        groupId:'',
        forward:'',
    })
    const profile = useSelector(state => state.users.ursData)

    const location = useLocation()
    const query = qs.parse(location.search, {arrayFormat: 'comma'});
    const crmData = useSelector(state => state.crm.crmData)
    const single = useSelector(state => state.sip.sipSingleData)
    const sipSingleStatus = useSelector(state => state.sip.sipSingleStatus)
    const sipTelegramData = useSelector(state => state.sip.sipTelegramData)
    const sipFix = useSelector(state => state.sip.sipFix)
    const [memberCrm,setMemCrm] = useState([])
    const [shorts,setShorts] = useState([])
    const [ivrs,setIvrs] = useState([])
    const [newCrm,setNewCrm] = useState({id:'',buddy:open})
    const [isTelegram,setIsTelegram] = useState(0)
    const [forTelegram,setForTelegram] = useState(0)
    const [access,setAccess] = useState(false)
    const [editCrm,setEditNewCrm] = useState({id:0,type:''})
    const dispatch = useDispatch()
    const handleEditChange = useCallback((name, ev) => {
        setEdit((prev) => ({
            ...prev,
            [name]: ev
        }))
    }, [])
    const handleWheel = useCallback((event) => {
        event.target.blur();
    },[]);
    const handleEdit = useCallback(async (ev) => {
        ev.preventDefault()
        const langIdx = +localStorage.getItem('atsLang') || 1
        if (!String(edit.note || '').trim()) {
            toast.error(langIdx === 2 ? 'Заметка обязательна' : langIdx === 3 ? 'Նշումը պարտադիր է' : 'Note is required')
            return
        }
        if(edit.pass !== edit.reenter){
            toast.error(lang[+localStorage.getItem('atsLang')] === 'en-AU' ? 'Passwords are not identical' : lang[+localStorage.getItem('atsLang')] === 'ru' ? 'Пароли не идентичны' : 'Գաղտնաբառերը նույնը չեն')
            return
        }
        if(edit.rec === 1){
            toast.error('Record count should be greater than 1')
            return
        }
        await dispatch(sipEditRequest(open,edit,Cookies.get("sip") ||query.limit || 10,query.page,query.search,window.location.pathname,query.sortBy || '', query.sortOrder || ''))
        setOpen(0)
    }, [edit,checked,lang,open,location.search])

    useEffect(() => {
        (async () => {
           await dispatch(sipSingleRequest(open))
           await dispatch(crmRequest())

           const {data} = await Api.shortForVirtual()
           setIvrs(data.short.filter(l => +l.isivr > 0).map(s => ({value:s.virtual,label:`${s.virtual} (${s.name})`})))
           setShorts(data.short.filter(l => +l.isivr === 0).map(s => ({value:s.virtual,label:`${s.virtual} (${s.name})`})))
        })()
    }, [open])

    useEffect(() => {
        setEdit({
            pass: '',
            rec: +single.rec,
            reenter: '',
            email: single.email || "",
            out: single.sipdid,
            sip_noanswer: single.sip_noanswer || "",
            isspyadmin: single.isspyadmin,
            rate: single.rate || 0,
            isspeech: single.isspeech || 0,
            mob: single?.codetypeResult?.find(c => c.id === 1) ? 1 : 0,
            fixed: single?.codetypeResult?.find(c => c.id === 2) ? 2 : 0,
            inter: single?.codetypeResult?.find(c => c.id === 3) ? 3 : 0,
            payed: single?.codetypeResult?.find(c => c.id === 4) ? 4 : 0,
            isSip: single.issip,
            isWeb: single.isweb || 0,
            history: single.oprec || 2,
            note: single.notes || '',
            forward: single?.redirect?.output || '',
            ip: single?.sip_buddy?.uagent || '',
            groupId: single?.pickupgroup?.split('_')[1] || '',
        })
        
        setMemCrm(single.crm)
        setTelegram({pass:'',buddy:open,phone:sipTelegramData?.phone_number})
        setForTelegram(sipTelegramData?.phone_number)
    }, [single,sipTelegramData,open,REACT_APP_SERVER])


    const handleDelete = useCallback(async (id) => {
        try{
            const {data} = await Api.crmDelete(id,open)
            setMemCrm(data.crm)
        }catch (e) {

        }
    },[open])

    if(sipSingleStatus === 'request'){
        return null
    }
    return (
       <>

           <Modal
               aria-labelledby="transition-modal-title"
               aria-describedby="transition-modal-description"
               open={!!open}
               onClose={() => setOpen(0)}
               closeAfterTransition
               slots={{backdrop: Backdrop}}
               slotProps={{
                   backdrop: {
                       timeout: 500,
                   },
               }}
           >
               <Fade in={!!open}>
                   <Box sx={style}>
                       <div className="d-flex flex-row justify-content-between">
                           <Typography id="transition-modal-title" variant="h6" component="h2">
                               {sip.edit[+localStorage.getItem('atsLang')  || 1 ]}
                           </Typography>
                           <span style={{cursor: 'pointer'}} onClick={() => setOpen(0)}>
                            <CloseIcon/>
                        </span>
                       </div>
                       <form onSubmit={handleEdit} id="transition-modal-description sip_content" >
                           <div className="row">
                               <label className="col-md-6 count" style={{margin: '20px 0'}}>
                                   <span>{sip.edit[+localStorage.getItem('atsLang')  || 1 ]}</span>
                                   <input style={{color: '#CCC'}} readOnly onChange={() => null} value={open.toString() || ''}/>
                               </label>
                               <label className="col-md-6 count" style={{margin: '20px 0'}}>
                                   <span>{sip.group[+localStorage.getItem('atsLang')  || 1 ]}</span>
                                   <input onWheel={handleWheel} type="number" value={edit.groupId || ''} onChange={(ev) => handleEditChange('groupId', ev.target.value)}/>
                               </label>

                               <label className="col-md-6 count " style={{margin: '20px 0'}}>
                                <span
                                    className="d-flex flex-row align-items-center justify-content-between">{sip.call_rec[+localStorage.getItem('atsLang')  || 1 ]}
                                    <input

                                    style={{width: 10}} checked={checked}
                                    onChange={(ev) => {
                                        if (!ev.target.checked){
                                            handleEditChange('rec', 0)
                                        }
                                        setChecked(ev.target.checked)
                                    }} type="checkbox"/></span>
                                   <input disabled={!checked} value={edit.rec||0}
                                          onChange={(ev) => handleEditChange('rec', checked ? +ev.target.value > 1100? 1100 :ev.target.value: 0)}
                                          type="number"
                                          onWheel={handleWheel}
                                   />


                               </label>

                               <label className="col-md-6 count" style={{margin: '20px 0'}}>
                                   <span>{sip.out[+localStorage.getItem('atsLang')  || 1 ]}</span>
                                   <Select
                                       styles={customStyles}
                                       menuPlacement="auto"
                                       menuPosition="fixed"
                                       onChange={(ev) => handleEditChange('out', ev.value)}
                                       menuPortalTarget={document.body}
                                       className="basic-single"
                                       classNamePrefix="select"
                                       isSearchable={true}
                                       value={{value:edit.out,label:edit.out,}}
                                       name="color"
                                       options={[{value:'',label:"Select"},...sipFix.map(k => (
                                           {value: k.name, label: `${k.name}`}
                                       ))]}
                                   />
                               </label>

                               <div className="col-md-6 count" style={{margin: '20px 0'}}>
                                   <p className="d-flex flex-row align-items-center">
                                    <span style={{
                                        marginBottom: 0,
                                        width: 200
                                    }}>{sip.mobile[+localStorage.getItem('atsLang')  || 1 ]}</span>
                                       <input checked={edit.mob || 0}
                                              onChange={(ev) => handleEditChange('mob', ev.target.checked ? 1 : 0)}
                                              style={{width: 50}} type="checkbox"/>
                                   </p>
                                   <p className="d-flex flex-row align-items-center">
                                    <span style={{
                                        marginBottom: 0,
                                        width: 200
                                    }}>{sip.fix_num[+localStorage.getItem('atsLang')  || 1 ]}</span>
                                       <input checked={edit.fixed || 0}
                                              onChange={(ev) => handleEditChange('fixed', ev.target.checked ? 2 : 0)}
                                              style={{width: 50}} type="checkbox"/>
                                   </p>
                                   <p className="d-flex flex-row align-items-center">
                                    <span style={{
                                        marginBottom: 0,
                                        width: 200
                                    }}>{sip.international[+localStorage.getItem('atsLang')  || 1 ]}</span>
                                       <input checked={edit.inter || 0}
                                              onChange={(ev) => handleEditChange('inter', ev.target.checked ? 3 : 0)}
                                              style={{width: 50}} type="checkbox"/>
                                   </p>
                                   <p className="d-flex flex-row align-items-center">
                                    <span style={{
                                        marginBottom: 0,
                                        width: 200
                                    }}>{sip.payed[+localStorage.getItem('atsLang')  || 1 ]}</span>
                                       <input checked={edit.payed || 0}
                                              onChange={(ev) => handleEditChange('payed', ev.target.checked ? 4 : 0)}
                                              style={{width: 50}} type="checkbox"/>
                                   </p>

                               </div>
                               {Cookies.get('viewer') ?<label className="col-md-6 count" style={{margin: '20px 0'}}>
                                   <p className="d-flex flex-row align-items-center">
                                    <span style={{
                                        marginBottom: 0,
                                        width: 200
                                    }}>{sip.num[+localStorage.getItem('atsLang')  || 1 ]}</span>
                                       <input checked={edit.isSip || 0}
                                              onChange={(ev) => handleEditChange('isSip', ev.target.checked ? 1 : 0)}
                                              style={{width: 50}} type="checkbox"/>
                                   </p>
                               </label>:null}

                               <label className="col-md-6 count" style={{margin: '20px 0',cursor:'pointer'}}>
                                   <hr/>
                                   <p className="addBtnBig evenBig" onClick={() => setAccess(true)}>{sip.access[+localStorage.getItem('atsLang')  || 1 ]} - {Utils.getTranslate(+edit.history)[+localStorage.getItem('atsLang')  || 1 ]}</p>
                               </label>
                               <label className="col-md-6 count justify-content-between" style={{margin: '20px 0'}}>
                                   <hr/>
                                   <p className="d-flex flex-row align-items-center">
                                    <span style={{
                                        marginBottom: 0,
                                        width: 200
                                    }}>{sip.rate[+localStorage.getItem('atsLang')  || 1 ]}</span>
                                       <input checked={edit.rate || 0}
                                              onChange={(ev) => handleEditChange('rate', ev.target.checked ? 1 : 0)}
                                              style={{width: 50}} type="checkbox"/>
                                   </p>
                                   {/* <p className="d-flex flex-row align-items-center">
                                    <span style={{
                                        marginBottom: 0,
                                        width: 200
                                    }}>{sip.spy[+localStorage.getItem('atsLang')  || 1 ]}</span>
                                       <input checked={edit.isspyadmin || 0}
                                              onChange={(ev) => handleEditChange('isspyadmin', ev.target.checked ? 1 : 0)}
                                              style={{width: 50}} type="checkbox"/>
                                   </p> */}
                                   {Cookies.get('viewer')?<p className="d-flex flex-row align-items-center">
                                    <span style={{
                                        marginBottom: 0,
                                        width: 200
                                    }}>Speech</span>
                                       <input checked={edit.isspeech || 0}
                                              onChange={(ev) => handleEditChange('isspeech', ev.target.checked ? 1 : 0)}
                                              style={{width: 50}} type="checkbox"/>
                                   </p>:null}
                               </label>
                               <hr/>
                               <label className="col-md-6 count" style={{margin: '20px 0'}}>
                                   <span>{sip.note[+localStorage.getItem('atsLang')  || 1 ]} *</span>
                                   <input required value={edit.note  || ''} onChange={(ev) => handleEditChange('note', ev.target.value)}/>
                               </label>
                               <label className="col-md-6 count" style={{margin: '20px 0'}}>
                                   <span>{sip.email[+localStorage.getItem('atsLang')  || 1 ]}</span>
                                   <input type="email" placeholder='email@example.com' value={edit.email  || ''} onChange={(ev) => handleEditChange('email', ev.target.value)}/>
                               </label>
                               <label className="col-md-12 count" style={{margin: '20px 0'}}>
                                   <span>{sip.noanswer[+localStorage.getItem('atsLang')  || 1 ]}</span>
                                   <Select
                                       styles={customStyles}
                                       menuPlacement="auto"
                                       menuPosition="fixed"
                                       onChange={(ev) => handleEditChange('sip_noanswer', ev.value)}
                                       menuPortalTarget={document.body}
                                       className="basic-single"
                                       classNamePrefix="select"
                                       isSearchable={true}
                                       value={{value:edit.sip_noanswer,label:[{value:'',label:input.select[+localStorage.getItem('atsLang')  || 1 ]},{value:"10888", label:sip.end_call[+localStorage.getItem('atsLang')  || 1 ]},
                                       {value:"10777", label:sip.repeat[+localStorage.getItem('atsLang')  || 1 ]},
                                       ...shorts,...ivrs].find(l => +l.value === +edit.sip_noanswer)?.label}}
                                       name="color"
                                       options={[{value:'',label:input.select[+localStorage.getItem('atsLang')  || 1 ]},
                                        {value:"10888", label:sip.end_call[+localStorage.getItem('atsLang')  || 1 ]},
                                        {value:"10777", label:sip.repeat[+localStorage.getItem('atsLang')  || 1 ]},
                                        {label:"SHORT", options: shorts},
                                        {label:"IVR", options: ivrs},

                                       ]}
                                   />
                               </label>
                               <label className="col-md-12 count" style={{margin: '20px 0'}}>
                                   <span style={{margin: 0}}>{sip.ip[+localStorage.getItem('atsLang')  || 1 ]}</span>
                                   <span>{single?.sip_buddy?.ipaddr}</span>
                                   <input value={edit.ip || ''} onChange={(ev) => handleEditChange('ip', ev.target.value)}/>
                               </label>
                               {Cookies.get('viewer')?<label className="col-md-12 count" style={{margin: '20px 0'}}>
                                   <span>{sip.forward[+localStorage.getItem('atsLang')  || 1 ]}</span>
                                   <input value={edit.forward  || ''} onChange={(ev) => handleEditChange('forward', ev.target.value)}/>
                               </label>:null}
                           </div>
                           <hr/>
                           <div className="telegram_block"><h3>Messanger</h3>
                               <span style={forTelegram?{background:'#3390ec'}:{}} onClick={()=> {
                                   if(forTelegram){
                                       setIsTelegram(open)
                                   }else{
                                       setTelegram(prevState => ({...prevState, pass: code}))
                                   }
                               }} className="telegram_icon"><TelegramIcon /> </span>
                               {forTelegram?sipTelegramData?.phone_number || forTelegram:null}
                           </div>
                           <hr/>
                           <div className="d-flex justify-content-center">
                               <h5>{crm.crm[+localStorage.getItem('atsLang')  || 1 ]}</h5>
                           </div>
                           <div>
                               {memberCrm?.map((m,_) => (
                                   <div className="crm_single_block" key={_}>
                                       <div>{m?.crm_list?.name}</div>
                                       <div className="d-flex">
                                           {Cookies.get('viewer')&& +profile?.admingroup === 2?null:<span style={{background:'#ccc'}} className="addBtn" onClick={() => {setNewCrm((prev) => ({...prev,id:m?.crm_list?.id.toString(),buddy:open})); setEditNewCrm({id:m.id,type: 'view'}) }}>View</span>}
                                           {Cookies.get('viewer')&& +profile?.admingroup === 2?null:(<span className="addBtn edit" onClick={() => {
                                               setNewCrm((prev) => ({...prev,id:m?.crm_list?.id.toString(),buddy:open})); setEditNewCrm({id:m.id,type: 'edit'}) }}>Edit</span>)}
                                           <span className="addBtn del" onClick={() => handleDelete(m.id)}>Delete</span>
                                       </div>
                                   </div>
                               ))}
                           </div>
                           <label className="col-md-12 count" style={{margin: '20px 0'}}>
                               <select value={newCrm.id} onChange={(ev) => {
                                   setNewCrm((prev) => ({...prev, id: ev.target.value, buddy: open}))
                                   setEditNewCrm({id:0,type: ''})
                               }}
                                       style={{height: 40, border: '1px solid #ccc',outline:'none'}}>
                                   <option key="7898789" value="">{input.select[+localStorage.getItem('atsLang')  || 1]}</option>
                                   {crmData?.map(c => (
                                       <option key={_.uniqueId()} value={c.id}>{c.name}</option>
                                   ))}
                               </select>
                           </label>
                           <div className="d-flex justify-content-center">
                               <button onClick={handleEdit} className="addBtnBig">
                                   {global.edit[+localStorage.getItem('atsLang')  || 1 ]}
                               </button>
                           </div>
                       </form>
                   </Box>
               </Fade>
           </Modal>
           {newCrm.id?<CreateAndEditCrm setEdit={setEditNewCrm} setCrm={setMemCrm} edit={editCrm} open={newCrm.id} buddy={newCrm.buddy} setOpen={setNewCrm} />:null}
           {telegram.pass?<Telegram setForTelegram={setForTelegram} open={telegram} setOpen={setTelegram} />:null}
           {access?<OperatorAccess setForm={setEdit} form={edit} setOpen={setAccess} open={access} />:null}
           {isTelegram?<TelegramDelete open={isTelegram} setForTelegram={setForTelegram} setOpen={setIsTelegram} />:null}
       </>
    );
}

export default EditSip;
